export default __webpack_public_path__ + "static/media/bg14.42daff93.jpg";